import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PageContainer } from '../../cockpit/_shared/page-container/page-container';
import { HeaderService } from '../../cockpit/_shared/header/header.service';
import { UserService } from '../../cockpit/user/user.service';
import { TranslateService } from '@mono-repo/util';
import { ConfigService } from '../../config.service';
import { MailingService2 } from '@mono-repo/complex-components';

export enum VERIFYSTATE {
  LOADING,
  OK,
  ERROR,
}

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
})
export class VerifyEmailComponent extends PageContainer implements OnInit {
  @HostBinding('class') class = 'dt-c-interactive-dialog';

  public VERIFYSTATE = VERIFYSTATE;

  private token: string;
  public isVerified: VERIFYSTATE;
  public errormsg: string;
  public pageSubheadingOk: string;

  constructor(
    headerService: HeaderService,
    translateService: TranslateService,
    private route: ActivatedRoute,
    private userService: UserService,
    private mailingService2: MailingService2,
    private readonly configService: ConfigService,
    private router: Router,
  ) {
    super(headerService, translateService);
  }

  ngOnInit() {
    this.setTranslateModule('verifyEmail');

    this.pageSubheadingOk = this.translateService.translate('PAGE_SUBHEADING_OK');

    this.isVerified = VERIFYSTATE.LOADING;
    this.errormsg = '';

    this.token = this.route.snapshot.paramMap.get('token');

    this.mailingService2.verifyEmail(this.token).subscribe(
      () => {
        this.isVerified = VERIFYSTATE.OK;
        this.userService.verifyEmail(true);
      },
      () => {
        this.isVerified = VERIFYSTATE.ERROR;
        // error is now an object that comes from odata service. If you want to use it here, you hav to extract the message first
        //this.errormsg = error;
        //console.error(error);
      },
    );
  }

  public routeToLogin(): void {
    if (this.configService.getConfig().initialRoute) {
      this.router.navigate([`/${this.configService.getConfig().initialRoute}`]);
    } else {
      this.router.navigate(['/login']);
    }
  }
}
